import { Box, Spinner } from '@chakra-ui/react';
import * as React from 'react';

const LoadingLayout = (props) => (
  <Box w='100%' h='100%'>
    {props.isLoading ? (
      <Box pos='fixed' top='50%' left='50%' w='100%' h=' 100%' z-index=' 9999'>
        <Spinner />
      </Box>
    ) : (
      <>{props.children}</>
    )}
  </Box>
);

export default LoadingLayout;
